module.exports = __webpack_public_path__ + "img/book2.bae2bd91.png";